import React from 'react';
import { MonitorIcon, ImageIcon, LayoutGridIcon } from 'lucide-react';
import { BookingSlot, MediaType, BrandRequest } from '../../data/types';
import { TimelineSlot } from './TimelineSlot';
interface MediaTypeRowProps {
  mediaType: MediaType;
  slots: BookingSlot[];
  isAdmin: boolean;
  brandRequests: BrandRequest[];
  onSlotClick: (slot: BookingSlot) => void;
}
const mediaTypeIcons: Record<MediaType, React.ReactNode> = {
  'Digital Outposts': <LayoutGridIcon className="w-4 h-4" data-id="element-991" />,
  'Digital Drive Aisle': <ImageIcon className="w-4 h-4" data-id="element-992" />,
  'Digital Windows': <MonitorIcon className="w-4 h-4" data-id="element-993" />
};
export function MediaTypeRow({
  mediaType,
  slots,
  isAdmin,
  brandRequests,
  onSlotClick
}: MediaTypeRowProps) {
  const sortedSlots = [...slots].sort((a, b) => a.weekNumber - b.weekNumber);
  return <div className="flex border-b border-border last:border-b-0" data-id="element-994">
      <div className="w-48 flex-shrink-0 px-4 py-4 bg-surface-warm border-r border-border" data-id="element-995">
        <div className="flex items-center gap-2" data-id="element-996">
          <span className="text-text-secondary" data-id="element-997">
            {mediaTypeIcons[mediaType]}
          </span>
          <span className="text-sm font-medium text-text-primary" data-id="element-998">
            {mediaType}
          </span>
        </div>
      </div>

      <div className="flex-1 overflow-x-auto" data-id="element-999">
        <div className="flex gap-2 p-3" data-id="element-1000">
          {sortedSlots.map(slot => <TimelineSlot key={slot.id} slot={slot} isAdmin={isAdmin} brandRequests={brandRequests} onClick={() => onSlotClick(slot)} data-id="element-1001" />)}
        </div>
      </div>
    </div>;
}